"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _FlamingoSwapRouteHandler_invokeReserves, _FlamingoSwapRouteHandler_createSwapRoute, _FlamingoSwapRouteHandler_getShortestRoutePath;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamingoSwapRouteHandler = void 0;
const neon_dappkit_1 = require("@cityofzion/neon-dappkit");
const neon_dappkit_types_1 = require("@cityofzion/neon-dappkit-types");
const NeonDappKitInvocationBuilderNeo3_1 = require("../../../builder/invocation/NeonDappKitInvocationBuilderNeo3");
const FlamingoSwapHelper_1 = require("../../../helpers/FlamingoSwapHelper");
class FlamingoSwapRouteHandler {
    static calculateBestRouteForSwap({ tokenToUse, tokenToReceive, network, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const routePath = __classPrivateFieldGet(this, _a, "m", _FlamingoSwapRouteHandler_getShortestRoutePath).call(this, {
                network,
                startToken: tokenToUse,
                targetToken: tokenToReceive,
            });
            if (routePath.length === 0)
                return [];
            const isWrapOrUnwrapNeo = FlamingoSwapHelper_1.FlamingoSwapHelper.isWrapNeo(network, [tokenToUse, tokenToReceive]) ||
                FlamingoSwapHelper_1.FlamingoSwapHelper.isUnwrapNeo(network, [tokenToReceive, tokenToUse]);
            if (isWrapOrUnwrapNeo) {
                const swapRoute = [
                    {
                        reserveTokenToReceive: '0',
                        reserveTokenToUse: '0',
                        tokenToReceive,
                        tokenToUse,
                    },
                ];
                return swapRoute;
            }
            const { stack: reservesStack } = yield __classPrivateFieldGet(this, _a, "m", _FlamingoSwapRouteHandler_invokeReserves).call(this, { network, routePath });
            return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapRouteHandler_createSwapRoute).call(this, { network, routePath, reservesStack });
        });
    }
    static createPoolGraph(network) {
        const poolGraph = {};
        const pools = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapPools(network);
        const tokens = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapTokens(network);
        const { NEO, bNEO } = tokens;
        // Initialize poolGraph with empty arrays
        Object.keys(tokens).forEach(tokenSymbol => {
            poolGraph[tokenSymbol] = [];
        });
        // Add edges to poolGraph
        Object.values(pools).forEach(pool => {
            const tokenASymbol = pool.tokens[0].symbol;
            const tokenBSymbol = pool.tokens[1].symbol;
            poolGraph[tokenASymbol].push(tokenBSymbol);
            poolGraph[tokenBSymbol].push(tokenASymbol);
        });
        // Remove duplicates from poolGraph
        Object.keys(tokens).forEach(tokenSymbol => {
            poolGraph[tokenSymbol] = Array.from(new Set(poolGraph[tokenSymbol]));
        });
        // Include NEO to the poolGraph
        poolGraph[NEO.symbol] = Object.keys(tokens).filter(tokenSymbol => tokenSymbol === bNEO.symbol);
        // Include relationship between NEO and bNEO
        poolGraph[bNEO.symbol].push(NEO.symbol);
        return poolGraph;
    }
}
exports.FlamingoSwapRouteHandler = FlamingoSwapRouteHandler;
_a = FlamingoSwapRouteHandler, _FlamingoSwapRouteHandler_invokeReserves = function _FlamingoSwapRouteHandler_invokeReserves({ network, routePath }) {
    return __awaiter(this, void 0, void 0, function* () {
        const invoker = yield neon_dappkit_1.NeonInvoker.init({
            rpcAddress: network.url,
        });
        const scriptHashes = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapScriptHashes(network);
        const routerScriptHash = scriptHashes.flamingoSwapRouter;
        // Remove NEO token from the routePath because it's not supported by the router
        const routePathWithoutNeo = routePath.filter(route => !FlamingoSwapHelper_1.FlamingoSwapHelper.isNeoToken(network, route.tokenToUse) &&
            !FlamingoSwapHelper_1.FlamingoSwapHelper.isNeoToken(network, route.tokenToReceive));
        const getReservesContractInvocations = routePathWithoutNeo.map(route => NeonDappKitInvocationBuilderNeo3_1.NeonDappKitInvocationBuilderNeo3.getReservesContractInvocation({
            routerScriptHash,
            tokenToUseHash: route.tokenToUse.hash,
            tokenToReceiveHash: route.tokenToReceive.hash,
        }));
        const getReservesContractInvocationMulti = {
            invocations: [...getReservesContractInvocations],
        };
        return yield invoker.testInvoke(getReservesContractInvocationMulti);
    });
}, _FlamingoSwapRouteHandler_createSwapRoute = function _FlamingoSwapRouteHandler_createSwapRoute({ network, routePath, reservesStack }) {
    const isNeoTokenToUse = FlamingoSwapHelper_1.FlamingoSwapHelper.isNeoToken(network, routePath[0].tokenToUse);
    const isNeoTokenToReceive = FlamingoSwapHelper_1.FlamingoSwapHelper.isNeoToken(network, routePath[routePath.length - 1].tokenToReceive);
    const swapRoute = [];
    for (let index = 0; index < reservesStack.length; index++) {
        const item = reservesStack[index];
        if (!neon_dappkit_types_1.TypeChecker.isStackTypeArray(item) ||
            !neon_dappkit_types_1.TypeChecker.isStackTypeInteger(item.value[0]) ||
            !neon_dappkit_types_1.TypeChecker.isStackTypeInteger(item.value[1])) {
            throw new Error('Invalid reserves response');
        }
        // Include NEO token in the swapRoute with 0 reserves because it wasn't supported by the router during the reserves invocation
        if (isNeoTokenToUse && index === 0) {
            swapRoute.push({
                tokenToUse: routePath[index].tokenToUse,
                reserveTokenToUse: '0',
                tokenToReceive: routePath[index].tokenToReceive,
                reserveTokenToReceive: '0',
            });
            index++;
        }
        swapRoute.push({
            tokenToUse: routePath[index].tokenToUse,
            reserveTokenToUse: item.value[1].value,
            tokenToReceive: routePath[index].tokenToReceive,
            reserveTokenToReceive: item.value[0].value,
        });
    }
    // Include NEO token in the swapRoute with 0 reserves because it wasn't supported by the router during the reserves invocation
    if (isNeoTokenToReceive) {
        swapRoute.push({
            tokenToUse: routePath[routePath.length - 1].tokenToUse,
            reserveTokenToUse: '0',
            tokenToReceive: routePath[routePath.length - 1].tokenToReceive,
            reserveTokenToReceive: '0',
        });
    }
    return swapRoute;
}, _FlamingoSwapRouteHandler_getShortestRoutePath = function _FlamingoSwapRouteHandler_getShortestRoutePath({ network, startToken, targetToken }) {
    // Initialize an empty object to track predecessors of each token
    const predecessor = {};
    // Create a graph representation of the token network
    const poolGraph = this.createPoolGraph(network);
    // Initialize the queue with the start token's symbol
    const queue = [startToken.symbol];
    // Track visited tokens, starting with the start token marked as visited
    const tokensVisited = {
        [startToken.symbol]: true,
    };
    // Initialize an empty array to store the path of tokens
    let path = [];
    while (queue.length) {
        // Remove and get the first token symbol from the queue
        const currentTokenSymbol = queue.shift();
        if (!currentTokenSymbol)
            break;
        const currentToken = FlamingoSwapHelper_1.FlamingoSwapHelper.getFlamingoSwapToken(network, currentTokenSymbol);
        if (!currentToken)
            continue;
        // Get the neighbors of the current token from the graph
        const neighbours = poolGraph[currentToken.symbol];
        for (const neighbourSymbol of neighbours || []) {
            if (tokensVisited[neighbourSymbol])
                continue; // Skip if the neighbor has already been visited
            // Mark the neighbor token as visited
            tokensVisited[neighbourSymbol] = true;
            // Record the current token as the predecessor of the neighbor token
            predecessor[neighbourSymbol] = currentToken;
            // Add the neighbor token symbol to the queue
            queue.push(neighbourSymbol);
            if (neighbourSymbol === targetToken.symbol) {
                // Initialize the path with the target token
                path = [targetToken];
                // Start reconstructing the path from the target token back to the start token
                let prevToken = currentToken;
                while (prevToken && prevToken.symbol !== startToken.symbol) {
                    path.push(prevToken); // Add the predecessor token to the path
                    prevToken = predecessor[prevToken.symbol]; // Move to the predecessor token
                }
                // If the start token is reached, add it to the path and reverse the path to start-to-end order
                if (prevToken) {
                    path.push(prevToken);
                    path.reverse();
                }
                break;
            }
        }
        if (path.length)
            break;
    }
    const routePath = [];
    // Convert the token path into route paths
    for (let i = 0; i < path.length - 1; i++) {
        routePath.push({ tokenToUse: path[i], tokenToReceive: path[i + 1] });
    }
    return routePath;
};
